import { Grid, Typography } from "@material-ui/core";
import { HashLink } from "react-router-hash-link";
import { AnnotationText } from "../annotation";
import { initAnnotations } from "../annotation-api";
import { documentApi2 } from "../document-api";
import { SuperChart } from "../document-types";
import { SectionTable, santitizeContent } from "./superchart-tables";
import { withTooltip } from "../../format";
import { originalOrange } from "../../theme";

const tabular = true;

const scrollToElement = (el: any) => {
  el.scrollIntoView({ behavior: "smooth", block: "start" });
};
interface SuperChartProps {
  superChart: SuperChart;
}

function routeToTable(content: string | object) {
  if (!tabular) {
    return false;
  }
  if (typeof content === "string") {
    return content.charAt(0) === "{" || content.charAt(0) === "[";
  }
  return true;
}

function highlightColor(
  section: string,
  existing: string,
  highlight = "primary"
): any {
  const h = section === "Critical Care";
  return h ? highlight : existing;
}
export function SuperChartContentV2({ superChart }: SuperChartProps) {
  const bundleKey = documentApi2.data.getState().bundleKey;
  const feedback = documentApi2.getFeedback(bundleKey);
  const onSave = () => documentApi2.updateFeedback(bundleKey);
  return !superChart.headers ? (
    <div>Not Available</div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "70vw",
        position: "absolute",
        top: "56px",
      }}
      role="document"
    >
      <Grid
        container
        direction="column"
        style={{
          flexWrap: "nowrap",
          overflowY: "scroll",
          paddingLeft: "24px",
          paddingTop: "12px",
          position: "sticky",
          top: "56px",
          height: "90vh",
          width: 300,
        }}
        role="grid"
        id="superchart"
      >
        <Grid item style={{ height: "56px" }}></Grid>
        {superChart.headers.map((v, i) => (
          <Grid key={i} item role="gridcell" data-filed={i}>
            <HashLink
              style={{ color: highlightColor(v, "#444", originalOrange) }}
              to={`/documents#${v.replace(" ", "-")}`}
              scroll={(el) => scrollToElement(el)}
            >
              <Typography
                style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                variant="overline"
                color={highlightColor(v, "textSecondary")}
              >
                {v}
              </Typography>
            </HashLink>
          </Grid>
        ))}
      </Grid>
      <div
        style={{ width: "100%", height: "90vh", overflowY: "scroll" }}
        role="grid"
        data-filed="html"
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
          style={{ overflow: "scroll", padding: "12px" }}
        >
          <Grid item style={{ height: "48px" }}></Grid>
          {Object.entries(superChart.sections).map(([section, content], i) => (
            <Grid
              key={i}
              item
              id={section.replace(" ", "-")}
              style={{ paddingTop: 24 }}
            >
              {withTooltip(
                santitizeContent(content),
                <Typography
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  variant="h6"
                  color={highlightColor(section, "textSecondary")}
                >
                  {section}
                </Typography>
              )}

              {routeToTable(content) ? (
                SectionTable(content, section, bundleKey, feedback, onSave)
              ) : (
                <AnnotationText
                  api={initAnnotations(
                    content,
                    section,
                    bundleKey,
                    feedback,
                    onSave
                  )}
                  tag={section}
                  highlightColor={highlightColor(
                    section,
                    "textSecondary",
                    originalOrange
                  )}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}
